import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { initFlowbite } from "flowbite";
import { DotAnimationComponent } from "./core/components/loading/dot-animation/dot-animation.component";
import { NotificationAlertComponent } from "./core/components/notification/notification-alert.component";
import { filter, Subscription } from "rxjs";
import { LoadingService } from "./core/components/loading/loading.service";
import { NotificationService } from "./core";
import { AuthService, DotLoadingServices } from "./core";
import { AppHeaderComponent } from "./core/components/app-header/app-header.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationAlertComponent, DotAnimationComponent, AppHeaderComponent],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  hideHeader = signal<boolean>(false);
  isLoading = computed(() => this.dotLoadingServices.isLoading());
  notifications = computed(() => this.notificationService.notification());
  private route = inject(ActivatedRoute);

  private subscriptions: Subscription = new Subscription();

  constructor(
      private router: Router,
      protected loadingService: LoadingService,
      public notificationService: NotificationService,
      public dotLoadingServices: DotLoadingServices,
  ) {}

  ngOnInit() {
    initFlowbite();

    this.subscriptions.add(
        this.loadingService.isLoading.subscribe((isLoading) => {
          this.dotLoadingServices.set(isLoading);
        })
    );

    // Hide header on login, authentication, and home pages
    this.updateHeaderVisibility(this.router.url);
    this.subscriptions.add(
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
          this.updateHeaderVisibility(event.urlAfterRedirects);
        })
    );
  }

  private updateHeaderVisibility(url: string): void {
    const path = url.split('?')[0];
    this.hideHeader.set(
        path === '/' ||
        path.startsWith('/home') ||
        path.startsWith('/authentication') ||
        path.startsWith('/login')
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}